import { http } from '../../../../api/http';
import type { MovimientoTesoreria, MovimientoTesoreriaFiltro } from '../types/movimiento';

const ENDPOINT = '/tesoreria/movimiento';

export class MovimientoTesoreriaService {
  public static async getAll(filtro?: MovimientoTesoreriaFiltro): Promise<MovimientoTesoreria[]> {
    const params = new URLSearchParams();
    if (filtro?.fechaInicio) params.append('fechaInicio', filtro.fechaInicio);
    if (filtro?.fechaFin) params.append('fechaFin', filtro.fechaFin);
    if (filtro?.idCajaBanco) params.append('idCajaBanco', filtro.idCajaBanco.toString());
    if (filtro?.tipoMovimiento) params.append('tipoMovimiento', filtro.tipoMovimiento);
    if (filtro?.estado) params.append('estado', filtro.estado);
    const response = await http.get(`${ENDPOINT}?${params.toString()}`);
    return response.data;
  }

  public static async getById(id: number): Promise<MovimientoTesoreria> {
    const response = await http.get(`${ENDPOINT}/${id}`);
    return response.data;
  }

  public static async save(movimiento: Partial<MovimientoTesoreria>): Promise<MovimientoTesoreria> {
    const response = await http.post(ENDPOINT, movimiento);
    return response.data;
  }

  public static async anular(id: number): Promise<void> {
    await http.put(`${ENDPOINT}/${id}/anular`);
  }

  public static async delete(id: number): Promise<void> {
    await http.delete(`${ENDPOINT}/${id}`);
  }

  public static async generarNumero(): Promise<string> {
    const response = await http.get(`${ENDPOINT}/generar-numero`);
    return response.data;
  }
}
